import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/auth/authContext";
import Alert from "../layouts/Alert";
import "../../styles/fonts.css";
const ReAuthenticate = (props) => {
  const authContext = useContext(AuthContext);
  const { reAuthenticate, currentUser, loadUser } = authContext;

  const [pass, setPass] = useState("");
  const [auth, setAuth] = useState("empty");
  const onChange = (e) => {
    setPass(e.target.value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const res = await reAuthenticate(pass);
    if (res === "yes") {
      setAuth("success");
      props.history.push(`/account/${props.match.params.redirect}`);
    } else {
      setAuth("fail");
      props.history.push(`/viewaccount/${currentUser.uid}`);
      loadUser();
    }
  };

  return (
    <div>
      <h1 class='mb-4 upperfont'>Re Enter Your Password</h1>
      <hr></hr>
      <Alert />
      <form onSubmit={onSubmit}>
        <div class='form-group fontcool size11'>
          <label for='login-password'>Password</label>
          <input
            type='password'
            class={`form-control ${
              auth === "success"
                ? "is-valid"
                : auth === "fail"
                ? "is-invalid"
                : ""
            } simplefont`}
            id='login-password'
            onChange={onChange}
          />
        </div>
        {auth !== "success" ? (
          <button type='submit' class='btn btn-dark btn-block slantfont'>
            Go
          </button>
        ) : (
          <button type='button' class='btn btn-secondary' data-dismiss='modal'>
            Change Password
          </button>
        )}
      </form>
      <hr></hr>
      <small className="simplefont">
        Forgot Password?{" "}
        <Link to='/resetPass'>Reset Password on your email</Link>
      </small>
    </div>
  );
};

export default ReAuthenticate;
